import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  fullWidth?: boolean;
  leftIcon?: ReactNode;
}

const styles: Record<Variant, string> = {
  primary:
    'bg-accent text-white hover:bg-accent-hover disabled:bg-ink-faint disabled:cursor-not-allowed',
  secondary:
    'bg-surface text-ink border border-line hover:bg-surface-muted disabled:text-ink-faint disabled:cursor-not-allowed',
  ghost: 'bg-transparent text-ink-muted hover:bg-surface-muted disabled:cursor-not-allowed',
};

export function Button({
  variant = 'primary',
  loading = false,
  fullWidth = false,
  leftIcon,
  children,
  disabled,
  className = '',
  ...rest
}: ButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 rounded-input px-4 py-3 text-sm font-medium transition-colors ${
        fullWidth ? 'w-full' : ''
      } ${styles[variant]} ${className}`}
      {...rest}
    >
      {loading ? <Spinner /> : leftIcon}
      <span>{children}</span>
    </button>
  );
}

function Spinner() {
  return (
    <span
      className="inline-block h-4 w-4 rounded-full border-2 border-white/40 border-t-white animate-spin"
      aria-hidden
    />
  );
}
